import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { setDateRange } from "./action";

const SelectMonthRange = ({ dateRange, minDate, maxDate }) => {
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    event.preventDefault();
  };

  const handleChange = (dates) => {
    const [startDate, endDate] = dates || [null, null];

    dispatch(
      setDateRange([
        {
          startDate,
          endDate,
          key: "reportMonth",
        },
      ])
    );
  };

  const startDate = dateRange?.[0]?.startDate || null;
  const endDate = dateRange?.[0]?.endDate || null;

  return (
    <DatePicker
      className="reco-filter-input"
      selected={startDate}
      onChange={handleChange}
      selectsRange
      startDate={startDate}
      endDate={endDate}
      dateFormat="MM-yyyy"
      showMonthYearPicker
      isClearable
      minDate={minDate ? new Date(minDate) : null}
      maxDate={maxDate ? new Date(maxDate) : null}
      onKeyDown={handleInputChange}
      onKeyPress={handleInputChange}
      placeholderText="Select Return Period"
    />
  );
};

export default SelectMonthRange;
